import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { CREATE_CART_API, FETCH_CART_STATS_SUCCESS, SET_CART_DATA } from "../actions/actionTypes";
import { getPurchasedItems } from "../../../utils/cart";
var getNewState = function getNewState(oldState, newData) {
  return _objectSpread(_objectSpread({}, oldState), {
    cartData: _objectSpread(_objectSpread({}, oldState.cartData), newData)
  });
};
var cartReducer = function cartReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    quantity: 0,
    items: [],
    cartApi: null
  };
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (action.type === FETCH_CART_STATS_SUCCESS) {
    return getNewState(state, {
      quantity: action.payload
    });
  }
  if (action.type === SET_CART_DATA) {
    return getNewState(state, {
      quantity: action.payload.quantity,
      currentCart: getPurchasedItems(action.payload.currentCart),
      cartRaw: action.payload.currentCart
    });
  }
  if (action.type === CREATE_CART_API) {
    return getNewState(state, {
      cartApi: action.payload
    });
  }
  return state;
};
export { cartReducer };